var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"info",staticClass:"info"},[_vm._v("Your only job is to FIGURE IT OUT.")])}
var staticRenderFns = []

export { render, staticRenderFns }